<div class="page-parent">
  <div class="header-container {{ serverName | lowercase }}" #headerContainer>
    <div class="header-left">
      <a [routerLink]="['/' + microAppBasePath()]">
        <div class="owl-logo"></div>
        <div class="owl"></div>
      </a>
      <div class="name" [id]="idPageName + '__micro-app-name'">
        {{ microAppDisplayName() }}
        <div>
          @if (serverName) {
            @if (nextShutDown$ | async; as nextShutDown) {
              <p class="stage-name" [tp]="nextShutDownTpl" [tpData]="nextShutDown$ | async">
                &nbsp; ( {{ serverName }} )
              </p>
            } @else {
              <p class="stage-name">&nbsp; ( {{ serverName }} )</p>
            }
          }

          <ng-template #nextShutDownTpl let-item="data">
            This environment will be disabled on {{ item | date: 'full' }}
          </ng-template>
        </div>
      </div>
    </div>
    <div class="header-right">
      <div class="inside">
        <button
          class="personal-details"
          type="button"
          #personalDetails
          [id]="idPageName + '__personal-details'"
          [attr.aria-expanded]="showHeaderFilterInformation()"
          [disabled]="!(headerFilterInfo$ | async)?.isClickable"
          (click)="onPersonalDetailsClicked()"
        >
          @if (officerPersonalDetails$ | async) {
            @if (showHeaderFilterInformation()) {
              <span class="preferred-specialties">
                @if ((headerFilterInfo$ | async)?.selectedFilters; as specialties) {
                  @if (specialties.length) {
                    <span class="preferred-specialties__container">
                      @for (specialty of specialties; track specialty) {
                        @if ($index < 5) {
                          <!--the index start from 0-->
                          <span
                            class="specialty-separator"
                            #separator
                            [style.visibility]="$index !== 0 ? 'visible' : 'hidden'"
                          >
                            ,&nbsp;
                          </span>
                          <span
                            class="specialty-name"
                            [id]="idPageName + '__' + specialty"
                            [title]="specialties"
                            [style.max-width.px]="
                              (personalDetails.offsetWidth -
                                75 -
                                separator.offsetWidth *
                                  (specialties.length > 5 ? 5 : specialties.length - 1)) /
                              (specialties.length > 5 ? 5 : specialties.length)
                            "
                          >
                            {{ specialty }}
                          </span>
                        }
                      }
                      @if ((headerFilterInfo$ | async)?.selectedFilters.length > 5) {
                        <span>
                          +{{ (headerFilterInfo$ | async)?.selectedFilters.length - 5 }} more
                        </span>
                      }
                    </span>
                  } @else {
                    {{ (headerFilterInfo$ | async)?.emptyText }}
                  }
                }
              </span>
            } @else {
              <span class="ellipsis organization-details-name" [title]="'See selected departments'">
                @if (officerPersonalDetails$ | async; as officerPersonalDetails) {
                  <span [id]="idPageName + '__officer-personal-details'">
                    {{ officerPersonalDetails.firstName + ' ' + officerPersonalDetails.lastName }}
                  </span>
                }
                <span>&#64;</span>
                <span [id]="idPageName + '__organization-details-name'">
                  {{ organizationDetailsName$ | async }}
                </span>
              </span>
            }
          }
        </button>
        <button
          class="sign-out"
          type="button"
          aria-label="Sign out"
          [id]="idPageName + '__logout'"
          (click)="logout()"
        >
          <span class="sign-out-icon"></span>
        </button>

        <button
          class="menu-trigger"
          type="button"
          aria-controls="layout-nav"
          [attr.aria-expanded]="responsiveMenuOpen()"
          [attr.aria-label]="responsiveMenuOpen() ? 'Close menu' : 'Open menu'"
          (click)="onResponsiveMenuOpen()"
        >
          <span class="burger-menu"></span>
        </button>
      </div>
    </div>
  </div>
</div>
<div id="layout-nav" class="layout-nav" [class.layout-nav--overlay]="responsiveMenuOpen()">
  <locumsnest-side-nav-bar
    class="left-nav-bar"
    [idx]="idPageName"
    [itemList]="navItems()"
    [filterCount]="(filterCount$ | async) ?? 0"
    [nestPanelExpanded]="showProductPanel()"
    [activeNavItem]="activeNavItemCode()"
    [filtersDisabled]="filtersDisabled()"
    [hospitalOfficerPath]="hospitalOfficerPath()"
    [isAgencyPlatform]="isAgencyPlatform()"
    [showMessagingPanel]="showMessagingPanel()"
    [hasUnreadMessages]="(hasUnreadMessages$ | async) ?? false"
    (toggled)="toggleProductPanel()"
    (clicked)="onOptionClicked()"
    (expanded)="onMenuExpanded($event)"
    (filterMenuClicked)="onToggleFiltersPanel()"
    (messagingMenuClicked)="onMessagingMenuClicked()"
  >
    @if (showProductPanel()) {
      <div
        class="side-nav-bar-content"
        animate.enter="panel-enter"
        animate.leave="panel-leave"
        [class.menu-expanded]="menuExpanded()"
        [style.--count]="microAppList().length"
      >
        <div class="nest">
          <button
            class="arrow-menu"
            type="button"
            aria-label="Close products"
            (click)="toggleProductPanel()"
          >
            <span class="menu-arrow"></span>
          </button>
          @for (microApp of microAppList(); track microApp.code; let i = $index) {
            <a
              class="nest-item"
              tpPlacement="right"
              [style.--index]="i"
              [id]="idPageName + '__side-menu__' + microApp.code"
              [routerLink]="microApp.link"
              [attr.aria-current]="microApp.isActive ? 'page' : null"
              [tp]="microApp.display"
              [tpIsEnabled]="!menuExpanded() && !responsiveMenuOpen()"
              [tpTippyProps]="{ touch: false }"
              (click)="changeProduct($event, microApp)"
            >
              <span [class]="'icon ' + microApp.code" [class.active]="microApp.isActive"></span>
              <span class="product-name">{{ microApp.display }}</span>
            </a>
          }
        </div>
      </div>
    }
  </locumsnest-side-nav-bar>
</div>

<div id="page-container" class="page-container">
  <div class="scroller" #scroller>
    @if (alertState(); as alertState) {
      <div>
        <locumsnest-toast
          [alertType]="alertState.type"
          [message]="alertState.message"
          [displayAlert]="alertState.displayAlertMessage"
          (toastClicked)="onAlertToastClicked()"
        />
      </div>
    }
    <router-outlet name="common-component" />
    @if (showFiltersPanel()) {
      <div class="overlay">
        <router-outlet name="filter-panel" />
      </div>
    }
    <div>
      <router-outlet name="messaging-panel" />
    </div>
    <router-outlet />
  </div>
</div>
